import SelectorEngine from '../../utils/dom/selector-engine';
import Modal from '../../components/Modal';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import attachValidation from '../../utils/form-validation';
import { getDataFromForm } from '../../utils/misc';

class EditCareer {
	constructor() {
		this._container = SelectorEngine.findOne('.js-edit-coach-details-career');

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._form = SelectorEngine.findOne('#lta-coach-details__edit-career-form', this._container);

		this._exitModal = new Modal(SelectorEngine.findOne('#coach-details-career-exit'), {});

		this._cancelCta = SelectorEngine.findOne('.lta-coach-details__edit-career-back', this._container);
		this._cancelCta.addEventListener('click', () => this._exitModal.show());

		const popupCancel = SelectorEngine.findOne('.lta-coach-details__edit-career-continue', this._container);
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-coach-details__edit-career-exit', this._container);
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		this._hideSectionWrapper = SelectorEngine.findOne('.lta-coach-details__edit-career', this._container);
		this.coachingRadioWrapper = SelectorEngine.findOne('.lta-coach-details-coaching-wrapper', this._hideSectionWrapper);
		this.offCOurtRadioWrapper = SelectorEngine.findOne(
			'.lta-coach-details-off-court-wrapper',
			this._hideSectionWrapper
		);
		this.qualificationRadioWrapper = SelectorEngine.findOne(
			'.lta-coach-details-qualification-wrapper',
			this._hideSectionWrapper
		);

		this._form.addEventListener('change', (event) => {
			this._openHiddenSection(event);
		});

		this._validationErrorText = SelectorEngine.findOne('.lta-text-input--error', this._hideSectionWrapper);

		this._errorContainer = SelectorEngine.findOne('.lta-edit-career-error-container', this._container);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});

		this.fv = attachValidation(this._form, {
			experience: {
				validators: {
					notEmpty: {
						message: 'Please select an option'
					}
				}
			},
			coachingPerWeek: {
				validators: {
					notEmpty: {
						message: 'Please select an option'
					}
				}
			},
			offCourtTasks: {
				validators: {
					notEmpty: {
						message: 'Please select an option'
					}
				}
			},
			qualification: {
				validators: {
					notEmpty: {
						message: 'Please select an option'
					}
				}
			}
		});
		this.fv.on('core.form.valid', () => {
			this.submitEnquiry(this._form);
		}); 

		this._openHiddenSection();
	}

	_openHiddenSection(event) {
		const experience = SelectorEngine.findOne('input[name = "experience"]:checked', this._form);
		const coachingRadioValue = SelectorEngine.findOne('input[name = "coachingPerWeek"]:checked', this._form);
		const offCourtTasksValue = SelectorEngine.findOne('input[name = "offCourtTasks"]:checked', this._form);
		if (experience?.value !== '') {
			this.coachingRadioWrapper?.classList.remove('u-hidden');
		}
		if (coachingRadioValue?.value !== '') {
			this.offCOurtRadioWrapper?.classList.remove('u-hidden');
		}
		if (offCourtTasksValue?.value !== '') {
			this.qualificationRadioWrapper?.classList.remove('u-hidden');
		}
	}

	async submitEnquiry(form) {
		startLoadingAnimation();

		const dataObject = getDataFromForm(form);

		const payload = {
			updateCoachDetailsRequest: {
				myCareer: {
					yearsOfExperience: dataObject.experience,
					hoursOfCoachingPerWeek: dataObject.coachingPerWeek,
					hoursOfOffCourtTasks: dataObject.offCourtTasks,
					consideringNextQualification: dataObject.qualification
				}
			}
		};

		try {
			const url = `/api/coachdetails/update`;
			const responseData = await Request.post(url, payload);

			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._container, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			this._errorContainer.scrollIntoView();
		} finally {
			stopLoadingAnimation();
		}
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalEditCareer = new EditCareer();

export default globalEditCareer;
